export const MRIGL_COMPANY_INFO = {
  commercialName: 'MRIGL',
  legalForm: 'SARL',
  registeredAddress:
    'Immeuble Les Jardins, avenue des Violettes, 1er étage, B1-1, Jardins El Manzeh 2, 2094 Ariana, Tunisie',
  phone: '+216 94 337 199',
  phoneHref: 'tel:+21694337199',
  country: 'Tunisie',
};

export const MRIGL_TAX_AND_FEES_INFO = {
  taxDetails:
    'Tous les prix affichés en dinars tunisiens (TND) sont TTC, taxes comprises.',
  extraFees:
    "Tous les frais sont inclus dans le prix affiché. Aucun frais supplémentaire n'est ajouté au paiement.",
  deliveryTerms:
    "Service numérique livré en ligne : l'accès au site, à l'éditeur, à l'hébergement et aux fonctionnalités incluses est activé après confirmation du paiement.",
};

export const MRIGL_SALES_CONDITIONS = {
  url: '/pages/terms-of-service',
  accessibleBeforePayment:
    "Les conditions commerciales sont accessibles publiquement avant paiement dans les conditions d'utilisation, depuis le pied de page et la page de paiement.",
  paymentTerms:
    'Paiement en TND via les moyens de paiement disponibles au checkout. Le plan est activé uniquement après confirmation du paiement.',
  cancellationPolicy:
    "L'utilisateur peut annuler le renouvellement depuis son compte. L'accès déjà payé reste disponible jusqu'à la fin de la période en cours.",
  returnRefundPolicy:
    "Le service étant numérique, l'accès est fourni après paiement. Une demande de retour, échange ou remboursement peut être étudiée par le support selon la situation et la loi applicable.",
  disputeResolution:
    'En cas de litige, contactez d’abord MRIGL afin de rechercher une solution amiable.',
  applicableLaw:
    'Les conditions sont soumises au droit tunisien et les litiges sont traités selon les règles applicables en Tunisie.',
};
